import { Trans } from '@/components'
import { formatBytes } from '@/utils/formatter'

interface SnapshotStorageBadgeProps {
  bytes: number
}

export function SnapshotStorageBadge({ bytes }: SnapshotStorageBadgeProps) {
  return (
    <div className="px-4 py-2 rounded-full bg-neutral-50 t-x-sb flex items-center gap-x-2">
      <span className="text-tertiary">
        <Trans i18nKey="snapshot.snapshotStorage">Snapshot Storage</Trans>
      </span>
      <span className="text-primary">{formatBytes(bytes) || '0 MB'}</span>
    </div>
  )
}
